/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListFinancialTransactionsQueryResponse, ListFinancialTransactionsPathParams, ListFinancialTransactionsQueryParams, ListFinancialTransactions400, ListFinancialTransactions401, ListFinancialTransactions403, ListFinancialTransactions404, ListFinancialTransactions409, ListFinancialTransactions500 } from "../../types/financialHubController/ListFinancialTransactions.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listFinancialTransactions } from "../../client/financialHubController/listFinancialTransactions.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listFinancialTransactionsQueryKey = (organizationId: ListFinancialTransactionsPathParams["organizationId"] | undefined, params?: ListFinancialTransactionsQueryParams) => [{ url: '/api/organizations/:organizationId/financial/transactions/', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListFinancialTransactionsQueryKey = ReturnType<typeof listFinancialTransactionsQueryKey>

export function listFinancialTransactionsQueryOptions(organizationId: ListFinancialTransactionsPathParams["organizationId"] | undefined, params?: ListFinancialTransactionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listFinancialTransactionsQueryKey(organizationId, params)
        return queryOptions<ListFinancialTransactionsQueryResponse, ResponseErrorConfig<ListFinancialTransactions400 | ListFinancialTransactions401 | ListFinancialTransactions403 | ListFinancialTransactions404 | ListFinancialTransactions409 | ListFinancialTransactions500>, ListFinancialTransactionsQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listFinancialTransactions(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List ledger transactions
 * {@link /api/organizations/:organizationId/financial/transactions/}
 */
export function useListFinancialTransactions<TData = ListFinancialTransactionsQueryResponse, TQueryData = ListFinancialTransactionsQueryResponse, TQueryKey extends QueryKey = ListFinancialTransactionsQueryKey>(organizationId: ListFinancialTransactionsPathParams["organizationId"] | undefined, params?: ListFinancialTransactionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListFinancialTransactionsQueryResponse, ResponseErrorConfig<ListFinancialTransactions400 | ListFinancialTransactions401 | ListFinancialTransactions403 | ListFinancialTransactions404 | ListFinancialTransactions409 | ListFinancialTransactions500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listFinancialTransactionsQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listFinancialTransactionsQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListFinancialTransactions400 | ListFinancialTransactions401 | ListFinancialTransactions403 | ListFinancialTransactions404 | ListFinancialTransactions409 | ListFinancialTransactions500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}